export const FETCH_GROUPS = 'FETCH_GROUPS';
export const GROUPS_SET_DOCS = 'GROUPS_SET_DOCS';
export const CREATE_GROUP = 'CREATE_GROUP';
export const SET_ADDGROUP = 'SET_ADDGROUP';
export const DELETE_GROUP = 'DELETE_GROUP';
export const SET_DELETEGROUP = 'SET_DELETEGROUP';
export const SETDELETE_GROUP = 'SETDELETE_GROUP';
